const currencySymbols = { 'ZAR': 'R' } as const

type Config = Partial<{
  currency: keyof typeof currencySymbols
  showSymbol: boolean
  maxScale: number
  minScale: number
}>

export function formatRands(value: number|undefined, config: Config = { }): string|undefined {
  if (value === undefined || value === null || isNaN(value)) {
    return undefined
  }

  const { currency = 'ZAR', showSymbol = true, maxScale = 4, minScale = 2 } = config

  const formattedValue = new Intl.NumberFormat(
    "en-ZA",
    {
      style: 'currency',
      currency,
      maximumFractionDigits: maxScale,
      minimumFractionDigits: minScale,
      currencySign: 'accounting',
      currencyDisplay: 'narrowSymbol',
    }
  ).format(value).replace(/,/g, '.')


  if (!showSymbol) {
    const currencySymbol = currencySymbols[currency]

    return formattedValue.replace(new RegExp(`^(\\()?(${currencySymbol}\\s*)(.*)$`), '$1$3')
  }

  return formattedValue
}
